<script setup>
defineProps({
  menuItemLabel: {
    type: String,
    required: true,
  },
  menuItemLocation: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <li>
    <a class="dropdown-item" :href="menuItemLocation">{{ menuItemLabel }}</a>
  </li>
</template>
